// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2RYgv","header":"ReportDetails_header__icYes","title":"ReportDetails_title__1H_oF","left":"ReportDetails_left__15qwa"};